interface IconProps {
  className?: string;
  color?: string;
}

// Chef d'exploitation - Tracteur
export function ChefExploitationIcon({ className = "w-12 h-12", color = "#0066CC" }: IconProps) {
  return (
    <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Corps du tracteur */}
      <rect x="35" y="45" width="40" height="20" fill={color} opacity="0.15" rx="2" />
      <rect x="35" y="45" width="40" height="20" fill="none" stroke={color} strokeWidth="2.5" rx="2" />

      {/* Cabine */}
      <rect x="50" y="30" width="15" height="15" fill={color} opacity="0.2" rx="1" />
      <rect x="50" y="30" width="15" height="15" fill="none" stroke={color} strokeWidth="2.5" rx="1" />

      {/* Fenêtre */}
      <rect x="53" y="33" width="9" height="7" fill="white" stroke={color} strokeWidth="1.5" rx="0.5" />

      {/* Roue arrière (grande) */}
      <circle cx="60" cy="65" r="12" fill="white" stroke={color} strokeWidth="2.5" />
      <circle cx="60" cy="65" r="6" fill="none" stroke={color} strokeWidth="2" />

      {/* Roue avant (petite) */}
      <circle cx="40" cy="65" r="8" fill="white" stroke={color} strokeWidth="2.5" />
      <circle cx="40" cy="65" r="4" fill="none" stroke={color} strokeWidth="2" />

      {/* Cheminée */}
      <rect x="67" y="35" width="3" height="10" fill={color} rx="1" />
      <circle cx="68.5" cy="33" r="2" fill={color} />
    </svg>
  );
}

// Ouvrier agricole - Personne avec outil
export function OuvrierAgricoleIcon({ className = "w-12 h-12", color = "#0066CC" }: IconProps) {
  return (
    <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Tête */}
      <circle cx="50" cy="30" r="8" fill={color} opacity="0.15" />
      <circle cx="50" cy="30" r="8" fill="none" stroke={color} strokeWidth="2.5" />

      {/* Chapeau */}
      <ellipse cx="50" cy="25" rx="10" ry="3" fill={color} opacity="0.3" />
      <rect x="45" y="20" width="10" height="6" fill={color} opacity="0.2" rx="1" />

      {/* Corps */}
      <path d="M 50 38 L 50 60" stroke={color} strokeWidth="3" strokeLinecap="round" />

      {/* Bras avec outil */}
      <path d="M 50 45 L 40 50 L 35 55" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
      <path d="M 50 45 L 60 42" stroke={color} strokeWidth="2.5" strokeLinecap="round" />

      {/* Outil (bêche) */}
      <rect x="30" y="55" width="8" height="15" fill={color} opacity="0.3" rx="1" />
      <rect x="30" y="55" width="8" height="15" fill="none" stroke={color} strokeWidth="2" rx="1" />

      {/* Jambes */}
      <path d="M 50 60 L 45 75" stroke={color} strokeWidth="3" strokeLinecap="round" />
      <path d="M 50 60 L 55 75" stroke={color} strokeWidth="3" strokeLinecap="round" />

      {/* Bottes */}
      <rect x="42" y="73" width="6" height="5" fill={color} opacity="0.3" rx="1" />
      <rect x="52" y="73" width="6" height="5" fill={color} opacity="0.3" rx="1" />
    </svg>
  );
}
